import http from "@services/httpService"
import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"

class BlockUserService {
  public async blockedUser(body: any) {
    const res = await http.post("api/services/app/Employees/BlockedUser", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async unblockUser(body: any) {
    const res = await http.post("api/services/app/Employees/UnblockUser", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async increaseErrorCount(body: any) {
    const res = await http.post(
      "api/services/app/Employees/IncreaseErrorCount",
      body
    )

    return res.data
  }
}

export default new BlockUserService()
